import React from 'react';
import classNames from 'classnames';
import { SIZES, APPEARANCES, TYPES, ALIGN } from './constants';
const getTagByType = (type) => {
  const tags = {
    [TYPES.paragraph]: 'p',
    [TYPES.listItem]: 'li',
    [TYPES.link]: 'a',
    [TYPES.label]: 'label',
    [TYPES.mark]: 'span',
    [TYPES.heading]: 'div',
  };

  return tags[type];
};

const Text = ({
  appearance = APPEARANCES.highEmphasis,
  children,
  className = '',
  size = SIZES.medium,
  type = TYPES.paragraph,
  align = ALIGN.left,
  weight = undefined,
  isUnderlined = false,
  isUppercase = false,
  isClipped = false,
  isHighlighted = false,
  linkConfig = undefined,
  labelConfig = undefined,
  onClick = Function.prototype,
}) => {
  const isTypeLink = type === TYPES.link && linkConfig;
  const isTypeLabel = type === TYPES.label && labelConfig;

  const classes = classNames(
    'ws-ui-text',
    `ws-ui-text--${size}`,
    `ws-ui-text--${appearance}`,
    `ws-ui-text--align-${align}`,
    `ws-ui-text--${type}`,
    className,
    {
      'ws-ui-text--underline': isUnderlined,
      'ws-ui-text--ellipsis': isClipped,
      'ws-ui-text--uppercase': isUppercase,
      'ws-ui-text--highlighted': isHighlighted,
      [`ws-ui-text--weight-${weight}`]: Boolean(weight),
    }
  );

  const linkAttributes = isTypeLink
    ? {
        href: linkConfig.href,
        rel: 'noreferrer',
        ...(linkConfig.target && { target: linkConfig.target }),
      }
    : {};

  const labelAttributes = isTypeLabel
    ? {
        for: labelConfig.for,
      }
    : {};

  const Tag = getTagByType(type);

  return (
    <Tag className={classes} {...linkAttributes} {...labelAttributes} onClick={onClick}>
      {children}
    </Tag>
  );
};

export default Text;
